import React from 'react';
import styled from 'styled-components';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// import $ from 'jquery';
import Icon from 'components/common/Icon';
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import DropdownButton from './DropdownButton';
import constants from 'lib/constants';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { subscribe } from 'graphql';

//------------------------------------------------------------------------------
// CONSTANTS:
//------------------------------------------------------------------------------

const SubscribeButton = styled.button`
  background-color: white;
  border: 1.5px solid ${p => p.theme.color.primary};
  padding: 7px 17px;
  cursor: pointer;
  font-size: 13px;
`;

const Logo = styled.img`
  height: 61px;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: justify-between;
  height: 100%;
`;

const HeaderOutter = styled.div`
  border-bottom: 1px solid #e1eaf2;
  position: fixed !important;
  background: #fff;
  top: 0px;
  right: 0px;
  left: 0px;
  z-index: 10;
`;

const HeaderContainer = styled.div`
  background: #fff;
  right: 0;
  left: 0;
  top: 0;
  z-index: 20;
  padding: 10px;
  font-weight: 600;
  margin: auto;
  width: ${p => p.theme.appWidth};

  .Layouts-Public-Header--authLinksContainer {
    text-align: center;
    margin-bottom: 7px;
  }
  .Layouts-Public-Header--authLink {
    font-size: 12px;
    color: #666 !important;
  }
  .Layouts-Public-Header--authIcon {
    font-size: 13px;
    margin-right: 5px;
  }
  .Layouts-Public-Header--loggedInLinksContainer {
    padding-top: 33px;
  }

  .Layouts-Public-Header--linksContainer {
    padding-top: 35px;
    width: 100%;
    max-width: 400px;
    margin-right: 50px;
  }
  .Layouts-Public-Header--link {
    font-size: 13px;
    font-weight: 700;
  }
`;

//------------------------------------------------------------------------------
// COMPONENT:
//------------------------------------------------------------------------------
export class Header extends React.Component {
  handleLinkClick = linkPath => {
    const {
      location: { pathname },
      history,
    } = this.props;

    // In case the user is in the home page ('/') and clicks in the 'PLANS'
    // link we should scroll down to #plans section
    if (pathname === '/' && linkPath === '/plans') {
      // this.scrollTo('plans');
    } else if (pathname !== '/' && linkPath === '/plans') {
      history.push('/');
    } else {
      history.push(linkPath);
    }
  };

  renderSubscribeButton = () => (
    <Link to="contact">
      <SubscribeButton>SUBSCRIBE NOW</SubscribeButton>
    </Link>
  );

  renderAuthLinks = () => (
    <div className="Layouts-Public-Header--authLinksContainer">
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Link to="/login" className="Layouts-Public-Header--authLink">
        <Icon type="login" className="Layouts-Public-Header--authIcon" />
        Login
      </Link>
    </div>
  );

  renderLoggedInLinks = () => (
    <div className="Layouts-Public-Header--loggedInLinksContainer">
      <DropdownButton {...this.props} />
      &nbsp;&nbsp;
    </div>
  );

  renderLinks = () => {
    //const { pathname } = this.props.location;
    return (
      <div className="flex justify-around ml-auto Layouts-Public-Header--linksContainer">
        {/* {pathname === '/' ? (
          <AnchorLink href="#home">HOME</AnchorLink>
        ) : (
          <a href="https://www.cclariti.com" target="_blank">
            HOME
          </a>
        )} */}
        <a href="https://www.cclariti.com" target="_blank">
            HOME
          </a>
        <a href="https://www.cclariti.com" target="_blank">
          PRODUCTS
        </a>
        {/* {pathname === '/' ? <AnchorLink href="#plans">PRODUCTS</AnchorLink> : <Link to="/">PRODUCTS</Link>} */}
        {this.props.currentUser ? <Link to="/contact">HELP</Link> : <Link to="/contact">SUBSCRIBE</Link>}
        {this.props.currentUser ? <DropdownButton {...this.props} /> : <Link to="/login">LOGIN</Link>}
      </div>
    );
  };

  render() {
    const { pathname } = this.props.location;
    return (
      <HeaderOutter>
        <HeaderContainer>
          <Row>
            <Col xs={4}>
              {pathname === '/' ? (
                <AnchorLink href="#home">
                  <Logo src={constants.images.logoBlack} alt="cclariti" />
                </AnchorLink>
              ) : (
                <Link to="/">
                  <Logo src={constants.images.logoBlack} alt="cclariti" />
                </Link>
              )}
            </Col>
            <Col xs={16}>
              <div>{this.renderLinks()}</div>
            </Col>
            <Col xs={4} style={{ paddingTop: 35 }}>
              <div>
                {/* {!currentUser && <div style={{ textAlign: 'center' }}>{this.renderAuthLinks()}</div>}
                {currentUser && <div>{this.renderLoggedInLinks()}</div>} */}
              </div>
            </Col>
          </Row>
        </HeaderContainer>
      </HeaderOutter>
    );
  }
}

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/layout/BlankLayout/Header/index.js